module.exports = __webpack_public_path__ + "static/media/danger-icon.e8e37106.svg";